import { Service } from '@angular/core';
import { environment } from '@env';
import { addRxPlugin, createRxDatabase, RxCollection, RxDatabase } from 'rxdb';
import { USER_SETTINGS_SCHEMA, UserSettingDoc } from '@app/schemas/user-settings.schema';
import { getRxStorageDexie, RxStorageDexie } from 'rxdb/plugins/storage-dexie';
import { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';
import { wrappedValidateAjvStorage } from 'rxdb/plugins/validate-ajv';

export type DatabaseCollections = {
	user_settings: RxCollection<UserSettingDoc>;
};

@Service()
export class LocalDbService {
	#db!: RxDatabase<DatabaseCollections>;
	#dbReadyPromise!: Promise<void>;

	constructor() {
		this.#dbReadyPromise = this.#initDb();
	}

	async #initDb() {
		let storage: RxStorageDexie;
		
		if (environment.production) {
			storage = getRxStorageDexie()
		} else {
			addRxPlugin(RxDBDevModePlugin);
			storage = wrappedValidateAjvStorage({
				storage: getRxStorageDexie()
			}) as RxStorageDexie;
		}

		this.#db = await createRxDatabase({
			name: 'ziggyDatabase',
			storage: storage
		});

		await this.#db.addCollections({
			user_settings: {
				schema: USER_SETTINGS_SCHEMA
			}
		});
	}

	async getCollections() {
		await this.#dbReadyPromise;
		return this.#db.collections;
	}
}
